/* ==========================================================================
   Collection grid.

   One job: tell the toolbar when it has actually stuck to the top, so the
   scroll edge under it fades in only while content is passing beneath. A
   permanent divider draws a line across the page even when nothing is behind
   it, which is the thing this avoids.

   Sorting and pagination are plain links and need no JavaScript at all. If
   this file fails to load the page still sorts, still paginates and still
   shops — the only thing lost is a soft edge under the bar.

   No scroll listener: an IntersectionObserver on the bar itself costs nothing
   per frame, where a scroll handler costs something on every one.
   ========================================================================== */
(function () {
  'use strict';

  function initBars(root) {
    (root || document).querySelectorAll('[data-cs-collbar]').forEach(function (bar) {
      if (bar.dataset.csBarReady) return;
      bar.dataset.csBarReady = '1';

      if (!('IntersectionObserver' in window)) return;

      // The bar sits at top: 0. Pulling the observer root up by one pixel means
      // the bar stops being fully visible the instant it becomes stuck, which
      // is exactly the moment the edge should appear.
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-stuck', entry.intersectionRatio < 1);
        });
      }, { threshold: [1], rootMargin: '-1px 0px 0px 0px' });

      io.observe(bar);
    });
  }

  function boot() { initBars(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // The theme editor re-renders a section in place, which drops the flag with
  // the old markup.
  document.addEventListener('shopify:section:load', function (e) { initBars(e.target); });
})();
